import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, complaint: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.COMPLAINT_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, complaint: null, error: null };
    case CONST.COMPLAINT_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, complaint: action.complaint, error: null };
    case CONST.COMPLAINT_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, complaint: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, complaint: null };
    default:
      return state;
  }
};
